/*
  Popcorn Projector: discount code field.
  Shows a discount code field above Add to cart on the landing page and product page,
  and above checkout in the cart drawer and on the cart page.
  Codes are applied to the Shopify cart itself, so they carry through to checkout,
  including Apple Pay, Google Pay and Shop Pay at checkout.
  Also makes the landing page Add to cart open the cart drawer instead of the cart page.
*/
(function () {
  if (window.ppDiscountLoaded) return;
  window.ppDiscountLoaded = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var FLASH_KEY = 'pp-discount-flash';
  var INVALID_MSG = "That code isn't valid for this order. Check the spelling and try again.";
  var memoryFlash = null;

  /* ---------- helpers ---------- */

  function setFlash(text, isError) {
    memoryFlash = { text: text, error: !!isError };
    try { sessionStorage.setItem(FLASH_KEY, JSON.stringify(memoryFlash)); } catch (e) {}
  }

  function takeFlash() {
    var f = memoryFlash;
    memoryFlash = null;
    try {
      if (!f) {
        var stored = sessionStorage.getItem(FLASH_KEY);
        if (stored) f = JSON.parse(stored);
      }
      sessionStorage.removeItem(FLASH_KEY);
    } catch (e) {}
    return f;
  }

  function request(path, body) {
    return fetch(ROOT + path, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined,
      credentials: 'same-origin'
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
        return data;
      });
    });
  }

  function getCart() { return request('cart.js'); }
  function getDrawer() { return document.querySelector('cart-drawer'); }
  function same(a, b) { return String(a).toLowerCase() === String(b).toLowerCase(); }
  function codesOf(cart) { return (cart.discount_codes || []).map(function (d) { return d.code; }); }
  function findCode(cart, code) {
    var list = cart.discount_codes || [];
    for (var i = 0; i < list.length; i++) if (same(list[i].code, code)) return list[i];
    return null;
  }
  function drawerSectionIds() {
    var drawer = getDrawer();
    if (!drawer || typeof drawer.getSectionsToRender !== 'function') return null;
    return drawer.getSectionsToRender().map(function (s) { return s.id; });
  }

  function updateCodes(codes, withDrawerSections) {
    var body = { discount: codes.join(',') };
    var ids = withDrawerSections ? drawerSectionIds() : null;
    if (ids) {
      body.sections = ids.join(',');
      body.sections_url = window.location.pathname;
    }
    return request('cart/update.js', body);
  }

  // Show the updated cart. Product page and drawer re-render the drawer; cart page reloads.
  function refresh(cart, context) {
    var drawer = getDrawer();
    if (context === 'cart') { window.location.reload(); return; }
    if (drawer && cart.sections && typeof drawer.renderContents === 'function') {
      if (cart.item_count > 0) drawer.classList.remove('is-empty');
      drawer.renderContents(cart);
      return;
    }
    window.location.href = ROOT + 'cart';
  }

  /* ---------- the field ---------- */

  function buildField(context, productForm, extraClass) {
    var wrap = document.createElement('div');
    wrap.className = 'pp-discount pp-discount--' + context + (extraClass ? ' ' + extraClass : '');
    var inputId = 'ppDiscount-' + context + '-' + Math.random().toString(36).slice(2, 7);
    wrap.innerHTML =
      '<form class="pp-discount__form" novalidate>' +
        '<label class="visually-hidden" for="' + inputId + '">Discount code</label>' +
        '<input id="' + inputId + '" class="pp-discount__input" type="text" name="discount" autocomplete="off" autocapitalize="characters" spellcheck="false" placeholder="Discount code">' +
        '<button type="submit" class="pp-discount__apply">Apply</button>' +
      '</form>' +
      '<p class="pp-discount__msg" role="status" aria-live="polite" hidden></p>' +
      '<ul class="pp-discount__codes" hidden></ul>';

    var form = wrap.querySelector('form');
    var input = wrap.querySelector('input');
    var applyBtn = wrap.querySelector('.pp-discount__apply');
    var msg = wrap.querySelector('.pp-discount__msg');
    var list = wrap.querySelector('.pp-discount__codes');

    function show(text, isError) {
      msg.textContent = text || '';
      msg.hidden = !text;
      msg.classList.toggle('is-error', !!isError);
    }

    function busy(on) {
      applyBtn.disabled = on;
      applyBtn.textContent = on ? 'Applying…' : 'Apply';
    }

    function renderCodes(cart) {
      if (context === 'product') return;
      var applied = (cart.discount_codes || []).filter(function (d) { return d.applicable; });
      list.innerHTML = '';
      applied.forEach(function (d) {
        var li = document.createElement('li');
        var label = document.createElement('span');
        label.textContent = d.code;
        var remove = document.createElement('button');
        remove.type = 'button';
        remove.textContent = '×';
        remove.setAttribute('aria-label', 'Remove code ' + d.code);
        remove.addEventListener('click', function () { removeCode(d.code); });
        li.appendChild(label);
        li.appendChild(remove);
        list.appendChild(li);
      });
      list.hidden = applied.length === 0;
    }

    // Product or landing page: add the selected projector to the cart, apply the code, open the drawer.
    function applyFromProduct(code) {
      var idInput = productForm && productForm.querySelector('[name="id"]');
      var variantId = Number(idInput && idInput.value);
      if (!variantId) return Promise.reject(new Error('Please choose an option first.'));
      var qtyInput = (productForm.id && document.querySelector('input[name="quantity"][form="' + productForm.id + '"]')) ||
        productForm.querySelector('[name="quantity"]');
      var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      var otherCodes = [];
      var added = false;

      return getCart()
        .then(function (cart) {
          otherCodes = codesOf(cart).filter(function (c) { return !same(c, code); });
          var alreadyInCart = cart.items.some(function (i) { return i.variant_id === variantId; });
          if (alreadyInCart) return null;
          added = true;
          return request('cart/add.js', { items: [{ id: variantId, quantity: qty }] });
        })
        .then(function () { return updateCodes(otherCodes.concat(code), true); })
        .then(function (cart) {
          var hit = findCode(cart, code);
          if (hit && hit.applicable) {
            setFlash('Code ' + hit.code + ' applied. You’re ready to check out.', false);
            show('Code applied. Your cart is ready.', false);
            input.value = '';
            refresh(cart, 'product');
            return;
          }
          // Not valid: put the cart back the way it was.
          return updateCodes(otherCodes, false)
            .then(function () {
              if (added) return request('cart/change.js', { id: String(variantId), quantity: 0 });
            })
            .then(function () { show(INVALID_MSG, true); });
        });
    }

    // Cart drawer or cart page: apply the code to the existing cart.
    function applyFromCart(code) {
      var otherCodes = [];
      var useDrawer = context === 'drawer';
      return getCart()
        .then(function (cart) {
          otherCodes = codesOf(cart).filter(function (c) { return !same(c, code); });
          return updateCodes(otherCodes.concat(code), useDrawer);
        })
        .then(function (cart) {
          var hit = findCode(cart, code);
          if (hit && hit.applicable) {
            setFlash('Code ' + hit.code + ' applied.', false);
            refresh(cart, context);
            return;
          }
          return updateCodes(otherCodes, false).then(function () { show(INVALID_MSG, true); });
        });
    }

    function removeCode(code) {
      show('', false);
      getCart()
        .then(function (cart) {
          var remaining = codesOf(cart).filter(function (c) { return !same(c, code); });
          return updateCodes(remaining, context === 'drawer');
        })
        .then(function (cart) {
          setFlash('Code ' + code + ' removed.', false);
          refresh(cart, context);
        })
        .catch(function (err) { show(err.message, true); });
    }

    form.addEventListener('submit', function (evt) {
      evt.preventDefault();
      evt.stopPropagation();
      var code = input.value.trim();
      if (!code) { show('Enter a code first.', true); input.focus(); return; }
      show('', false);
      busy(true);
      var run = context === 'product' ? applyFromProduct(code) : applyFromCart(code);
      run
        .catch(function (err) { show(err.message || 'Something went wrong. Please try again.', true); })
        .then(function () { busy(false); });
    });

    function init() {
      if (context === 'product') return;
      var f = takeFlash();
      if (f) show(f.text, f.error);
      getCart().then(renderCodes).catch(function () {});
    }

    return { el: wrap, init: init };
  }

  /* ---------- landing page Add to cart opens the drawer ---------- */

  function wireLandingAdd(formEl) {
    if (formEl.dataset.ppAjax) return;
    formEl.dataset.ppAjax = '1';
    formEl.addEventListener('submit', function (evt) {
      var ids = drawerSectionIds();
      if (!ids || !window.fetch) return; // no drawer: let the form post normally
      evt.preventDefault();
      var btn = formEl.querySelector('[type="submit"][name="add"]');
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
      var data = new FormData(formEl);
      data.append('sections', ids.join(','));
      data.append('sections_url', window.location.pathname);
      fetch(ROOT + 'cart/add.js', { method: 'POST', body: data, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
        .then(function (res) { return res.json().then(function (j) { if (!res.ok) throw new Error(j.description || 'Could not add to cart'); return j; }); })
        .then(function (state) {
          var drawer = getDrawer();
          drawer.classList.remove('is-empty');
          drawer.renderContents(state);
        })
        .catch(function () { formEl.submit(); })
        .then(function () { if (btn) { btn.disabled = false; btn.textContent = label; } });
    });
  }

  /* ---------- placement ---------- */

  function injectProduct() {
    var forms = document.querySelectorAll('.product__info-container product-form');
    Array.prototype.forEach.call(forms, function (pf) {
      if (pf.previousElementSibling && pf.previousElementSibling.classList.contains('pp-discount')) return;
      var formEl = pf.querySelector('form');
      if (!formEl) return;
      var field = buildField('product', formEl);
      pf.insertAdjacentElement('beforebegin', field.el);
      field.init();
    });
  }

  function injectLanding() {
    var forms = document.querySelectorAll('form.pp-form');
    Array.prototype.forEach.call(forms, function (formEl) {
      wireLandingAdd(formEl);
      if (formEl.previousElementSibling && formEl.previousElementSibling.classList.contains('pp-discount')) return;
      var field = buildField('product', formEl, 'pp-discount--landing');
      formEl.insertAdjacentElement('beforebegin', field.el);
    });
  }

  function injectDrawer() {
    var footer = document.querySelector('#CartDrawer .drawer__footer');
    if (!footer || footer.querySelector('.pp-discount')) return;
    var field = buildField('drawer');
    var anchor = footer.querySelector('.cart-drawer__footer');
    footer.insertBefore(field.el, anchor || footer.firstChild);
    field.init();
  }

  function injectCartPage() {
    var blocks = document.querySelector('#main-cart-footer .cart__blocks');
    if (!blocks || blocks.querySelector('.pp-discount')) return;
    var field = buildField('cart');
    var anchor = blocks.querySelector('.cart__ctas');
    blocks.insertBefore(field.el, anchor || blocks.firstChild);
    field.init();
  }

  function start() {
    injectLanding();
    injectProduct();
    injectDrawer();
    injectCartPage();

    // The drawer and cart page re-render themselves when the cart changes; put the field back each time.
    var pending = false;
    var observer = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        injectDrawer();
        injectCartPage();
      });
    });
    var drawer = getDrawer();
    if (drawer) observer.observe(drawer, { childList: true, subtree: true });
    var cartFooter = document.getElementById('main-cart-footer');
    if (cartFooter) observer.observe(cartFooter, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
